import {
  Box,
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  TabsProps,
} from "@chakra-ui/react";
import { TabSupplierProfile } from "../../../components/dashboard_supplier/TabSupplierProfile";
import { TabSupplierShippingAddress } from "../../../components/dashboard_supplier/TabSupplierShippingAddress";
import { TabBankAccount } from "../../../components/tab/TabBankAccount";
import { SupplierStoreProfileInterface } from "../../../constants/SupplierProfile";
import { useDarkWhiteColor } from "../../../themes/colors";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { TabExtendPremium } from "../../../components/dashboard_supplier/TabExtendPremium";

interface Props extends TabsProps {
  data: SupplierStoreProfileInterface | undefined;
  loaded: boolean;
  onRefreshProfile: () => void;
}

export const TabSupplierRoot = ({
  data,
  loaded = true,
  onRefreshProfile,
  ...rest
}: Props) => {
  const bgBnw = useDarkWhiteColor();
  const location = useLocation();
  const [tabIndex, setTabIndex] = useState<number>(0);
  const tabsRef = useRef<HTMLDivElement | null>(null);
  const queryParams = new URLSearchParams(location.search);
  const typeParams = queryParams.get("type") || "";

  useEffect(() => {
    typeParams === "changeBankAccount" && moveToBankAccount(2);
  }, [typeParams]);

  useEffect(() => {
    if (typeParams === "changeBankAccount") {
      const timer = setTimeout(() => {
        if (tabsRef.current) {
          tabsRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [typeParams]);

  const menuTab = [
    {
      id: 1,
      name: "Profil Supplier",
      element: (
        <TabSupplierProfile
          data={data?.profile}
          loaded={loaded}
          onRefreshProfile={() => onRefreshProfile()}
        />
      ),
    },
    {
      id: 2,
      name: "Alamat Pengiriman",
      element: (
        <TabSupplierShippingAddress data={data?.shipping} loaded={loaded} />
      ),
    },
    {
      id: 3,
      name: "Rekening Supplier",
      element: (
        <TabBankAccount
          data={data?.bankInformation}
          loaded={loaded}
          pageType={3}
        />
      ),
    },
    {
      id: 4,
      name: "Status Premium",
      element: <TabExtendPremium data={data?.premiumStatus} loaded={loaded} />,
    },
  ];

  const moveToBankAccount = (index: number) => {
    setTabIndex(index);
  };

  return (
    <Box ref={tabsRef}>
      <Tabs
        index={tabIndex}
        onChange={moveToBankAccount}
        w={"100%"}
        p={2}
        bg={bgBnw}
        borderRadius={"md"}
        position={"relative"}
        variant={"unstyled"}
        size={"sm"}
        {...rest}
      >
        <TabList>
          {menuTab.map((item) => (
            <Tab key={item.id}>{item.name}</Tab>
          ))}
        </TabList>

        <TabIndicator
          mt="-1.5px"
          height="2px"
          bg="red.400"
          borderRadius="1px"
        />

        <TabPanels>
          {menuTab.map((item) => (
            <TabPanel key={item.id}>{item.element}</TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
};
